import React from "react";
import PropTypes from "prop-types";

import { Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";

import warningIcon from "../../../../assets/images/warning-error.svg";
import dangerIcon from "../../../../assets/images/danger-error.svg";

const errorData = {
  danger: {
    icon: dangerIcon,
    alt: "danger icon",
    description:
      "Unable to perform authentication. Please contact the support team for more information.",
    visible: true,
  },
  warning: {
    icon: warningIcon,
    alt: "warning icon",
    description:
      "There is no SSO configuration enabled for this domain. Contact the support team or log in with your email and password.",
    visible: false,
  },
};

const ErrorSSO = ({ errorSSO, t }) => {
  return (
    <Container>
      <Row className="justify-content-center">
        <img
          src={errorData?.[errorSSO?.status]?.icon}
          alt={errorData?.[errorSSO?.status]?.alt}
          width={48}
          height={48}
        />
      </Row>
      <Row className="mt-4">
        <span className="text-center text-muted">
          {t(errorData?.[errorSSO?.status]?.description)}
        </span>
      </Row>
      {errorData?.[errorSSO?.status]?.visible && (
        <Row className="mt-4">
          <span className="text-center text-muted w-100 text-uppercase">
            [ERR-CODE&nbsp;{errorSSO?.error_code}]
          </span>
        </Row>
      )}
      <Row className="mt-5">
        <button
          className="btn btn-primary btn-block"
          type="button"
          onClick={() => (window.location.href = "/login")}
        >
          {t("To go Back")}
        </button>
      </Row>
    </Container>
  );
};
ErrorSSO.propTypes = {
  errorSSO: PropTypes.shape({
    error_code: PropTypes.string,
    status: PropTypes.string,
  }),
  t: PropTypes.func,
};
export default withTranslation()(ErrorSSO);
